module.exports = __webpack_public_path__ + "static/media/banner-video.1ed22cc9.mp4";